export default "https://d3fbpisbzpk8wt.cloudfront.net/20269944813/receiptScanNgCut-bundle-a85e696a3a2d9740b1dd135775bd925c.png";